export default __webpack_public_path__ + "static/media/uttarkhand.8137a4fd.jpg";